import { Page } from '@/core/architecture'

import { TopTemplate } from './template'
import { useViewModel } from './viewModel'

export const Top: Page = () => {
  const { state, actions } = useViewModel()

  return <TopTemplate state={state} onSkipSignUp={actions.skipSignUp} />
}
